export enum RequestSessionExitClickTarget {
  CANCEL_BUTTON = 'cancel button',
  EXIT_X_BUTTON = 'x button'
}
